import React from 'react';

import { useI18n, useSelector } from '~/Hooks';
import { HistoryOrder } from '../../index';
import { PaperTitle, Paper, Row, LeftBlock, RightBlock } from './styles';

interface Props {
  order: HistoryOrder | undefined;
}

export const Customer = (props: Props) => {
  const { i18n } = useI18n();
  const { order } = props;
  if (!order) return null;
  
  const { user } = order;
  const { company } = user;
  const { hasMembershipCards } = company;

  const membershipTitle = hasMembershipCards
    ? user.membershipCard?.membershipLevel?.title
    : user.membershipLevel?.title;

  return (
    <>
      <PaperTitle>{i18n('History.Customer')}</PaperTitle>
      <Paper>
        <Row>
          <LeftBlock>{order?.user?.name}</LeftBlock>
          {membershipTitle && <RightBlock>{i18n(membershipTitle)}</RightBlock>}
        </Row>

        <Row>
          <LeftBlock>{order?.user?.email}</LeftBlock>
          <RightBlock>{order?.user?.phone?.slice(2)}</RightBlock>
        </Row>
      </Paper>
    </>
  );
};
